import { render, staticRenderFns } from "./AppointmentDeliveryTimeDialog.vue?vue&type=template&id=1217a656&scoped=true&"
import script from "./AppointmentDeliveryTimeDialog.vue?vue&type=script&lang=ts&"
export * from "./AppointmentDeliveryTimeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1217a656",
  null
  
)

export default component.exports